import { render, staticRenderFns } from "./materialExtendItem.vue?vue&type=template&id=43f246be&scoped=true"
import script from "./materialExtendItem.vue?vue&type=script&lang=js"
export * from "./materialExtendItem.vue?vue&type=script&lang=js"
import style0 from "./materialExtendItem.vue?vue&type=style&index=0&id=43f246be&prod&lang=scss&scoped=true"
import style1 from "./materialExtendItem.vue?vue&type=style&index=1&id=43f246be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f246be",
  null
  
)

export default component.exports